import React from "react";
import MuiAvatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";

const styles = {
    avatar: {
        background:"white"
    },
    normal:{

    },
    small:{
         width: 30,
          height: 30,
    }
};



const AvatarView = ({ seed,gender, classes,size="normal" }) => {
    if(!gender||~['human','female','male','gridy'].indexOf(gender)){
        gender='fun-emoji';
    }
    
    return (
    <MuiAvatar
        className={classes.avatar+' '+classes[size]}
        variant="rounded"
        //src={seed && `https://avatars.dicebear.com/4.4/api/${gender||"human"}/${encodeURIComponent(seed.replace(/\//g,'').trim())}.svg`}
        src={seed && `https://api.dicebear.com/9.x/${gender||"human"}/svg?seed=${encodeURIComponent(seed.replace(/\//g,'').trim())}`}
    />
)};

const Avatar = withStyles(styles)(AvatarView);

export default Avatar;
